import { Fragment, useMemo } from 'react';
import { GameReportBetsProps } from './props';
import styles from './styles.module.scss';
import Bet from './Bet';
import Divider from '../Divider';

export default function GameReportBets({
  bets,
  isPending,
}: GameReportBetsProps) {
  const Bets = useMemo(
    () =>
      bets.map(bet => (
        <Fragment key={`game-report-bet-${bet.id}`}>
          <Bet bet={bet} isSingleBet={bets.length === 1} />
          <Divider />
        </Fragment>
      )),
    [bets],
  );

  return (
    <div className={styles.container}>
      {isPending ? <Bet isPending /> : Bets}
    </div>
  );
}
